import { useEffect, useState } from 'react';

export const linkType = {
  videoNotSupported: 'video_not_supported',
  voiceNotSupported: 'voice_not_supported',
  notificationNotSupported: 'notification_not_supported',
  none: 'none'
};

export type LinkType = typeof linkType[keyof typeof linkType];

interface GeneralPopupState {
  show: boolean;
  link: LinkType | null;
  title: string | null;
}

let state: GeneralPopupState = {
  show: false,
  link: null,
  title: null
};

const listeners = new Set<(newState: GeneralPopupState) => void>();

const setState = (newState: Partial<GeneralPopupState>) => {
  state = { ...state, ...newState };
  listeners.forEach((listener) => listener(state));
};

export const showGeneralPopup = (title: string, link: LinkType = linkType.none) => {
  setState({ show: true, title, link });
};

export const dismissPopup = () => {
  setState({ show: false, title: null, link: null });
};

export const useGeneralPopup = () => {
  const [popupState, setPopupState] = useState(state);

  useEffect(() => {
    listeners.add(setPopupState);
    return () => {
      listeners.delete(setPopupState);
    };
  }, []);

  return popupState;
};
